import React from 'react';

// local dependencies
import { withHeaderAndFooter } from 'ui/hoc/withHeaderAndFooter';
import { widgetError as WidgetError } from 'ui/views/widgets/widgetError';
import { heartBeatPreloader as HeartBeatPreloader } from 'ui/views/generic/heartBeatPreloader';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { widgetsTabFlow as WidgetsTabFlow } from 'modules/widgetsTabFlow';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { administration as Administration } from 'ui/views/widgets/administration';
 *
 * // render
 * <Administration propName='propValue'/>
 */

const administrationError = () => {
    return (
        <div className='ui-administration'>
            <WidgetError size='large'/>
        </div>
    );
};

// set display name
administrationError.displayName = 'administrationError';

// set default props
administrationError.defaultProps = {};

// prop types
administrationError.propTypes = {};

/************************************************************** */

const _administrationSuccess = ( props ) => {
    
    return (
        <div className='ui-administration'>
            <WidgetsTabFlow
                tabs={ props.tabs }
                theme='plain'
                requestPayload={ props.requestPayload }
            />
        </div>
    );
};

// set display name
_administrationSuccess.displayName = 'administrationSuccess';

// set default props
_administrationSuccess.defaultProps = {};

// prop types
_administrationSuccess.propTypes = {};

// view with header and footer
const administrationSuccess = withHeaderAndFooter( _administrationSuccess );

/************************************************************** */

const administrationPreloader = () => {
    return (
        <div className='ui-administration-preloader'>
            <HeartBeatPreloader className='ui-administration-preloader__animation' />
        </div>
    );
};

// set display name
administrationPreloader.displayName = 'administrationPreloader';

// set default props
administrationPreloader.defaultProps = {};

// prop types
administrationPreloader.propTypes = {};

/************************************************************** */

export const administration = withNetworkState( administrationPreloader, administrationSuccess, administrationError );
